import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_CATEGORIES_APP_PATHS } from '../constants/categories-app-paths.constants';
import AdminCategoriesListView from '../views/admin/AdminCategories.view';

export default function AdminCategoriesRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_CATEGORIES_APP_PATHS.CATEGORIES_LIST} component={AdminCategoriesListView} />
    </React.Fragment>
  );
}
